<template>
	<div class="home-page" style="background-color: #001A33;">
		<el-container class="home-layout">
		  <el-aside
		    id="mobile-primary-navigation"
		    class="home-aside"
			:class="{
			  'is-floating': isMobile || !sidebarPinned,
			  'is-preview-visible': sidebarVisible,
			  'is-mobile-drawer': isMobile
			}"
			:width="sidebarWidth"
			:aria-hidden="!sidebarVisible"
			@mouseenter.native="handleSidebarMouseEnter"
			@mouseleave.native="handleSidebarMouseLeave">
			  <div class="a-left">
				  <div class="a-main-1">智能叠光控制系统</div>
				  <div class="a-left-menu">
					  <el-menu
					    :default-active="currentUrl"
					    class="el-menu-vertical-demo"
					    :unique-opened="true"
					    :router="true"
						@select="handleMenuSelect"
					    @open="handleOpen"
					    @close="handleClose">
						<el-menu-item index="indexVue" @click="currentUrl = 'indexVue';">平台首页</el-menu-item>
						<el-menu-item index="powerStation" @click="currentUrl = 'powerStation';">电站管理</el-menu-item>
						<el-menu-item index="deviceIndex" @click="currentUrl = 'deviceIndex';">设备管理</el-menu-item>
						<el-submenu index="device">
						  <template slot="title">设备信息</template>
						  <el-menu-item index="deviceOne" @click="currentUrl = 'deviceOne';">控制器数据</el-menu-item>
						  <el-menu-item index="deviceTwo" @click="currentUrl = 'deviceTwo';">电表数据</el-menu-item>
						</el-submenu>
						<el-submenu index="1-4">
						  <template slot="title">监测管理</template>
						  <el-menu-item index="powerAnaly" @click="currentUrl = 'powerAnaly';">电站监测</el-menu-item>
						  <el-menu-item index="deviceJianCe" @click="currentUrl = 'deviceJianCe';">设备监测</el-menu-item>
						</el-submenu>
						<el-menu-item index="deviceAnalysisVue" @click="currentUrl = 'deviceAnalysisVue';">分析管理</el-menu-item>
						<el-submenu index="deviceStaticv1">
						  <template slot="title">统计报表</template>
						  <el-menu-item index="deviceStatic" @click="currentUrl = 'deviceStatic';">设备报表</el-menu-item>
						  <el-menu-item index="deviceDbStatic" @click="currentUrl = 'deviceDbStatic';">计量报表</el-menu-item>
						</el-submenu>
						<el-menu-item index="warnListVue" @click="currentUrl = 'warnListVue';">告警管理</el-menu-item>
						<el-menu-item index="userIndex" @click="currentUrl = 'userIndex';" v-if="canEdit === 1">账号管理</el-menu-item>
						<el-menu-item index="feedbackManageIndex" @click="currentUrl = 'feedbackManageIndex';" v-if="userLevel === 1">反馈管理</el-menu-item>
						<el-menu-item index="openApiDocIndex" @click="currentUrl = 'openApiDocIndex';" v-if="userLevel === 1">开放接口文档</el-menu-item>
						<el-menu-item index="oauthClientIndex" @click="currentUrl = 'oauthClientIndex';" v-if="userLevel === 1">开放接口授权</el-menu-item>
					  </el-menu>
				  </div>
			  </div>
			  <button
			    type="button"
				class="sidebar-pin-button"
				:title="sidebarToggleTitle"
				:aria-label="sidebarToggleTitle"
				@click.stop="handleSidebarToggle">
				<i :class="isMobile ? 'el-icon-close' : (sidebarPinned ? 'el-icon-arrow-left' : 'el-icon-lock')"></i>
			  </button>
		  </el-aside>
		  <button
		    v-if="isMobile && mobileSidebarOpen"
			type="button"
			class="sidebar-scrim"
			aria-label="关闭导航菜单"
			@click="closeMobileSidebar"></button>
		  <div
		    v-if="!isMobile && !sidebarPinned"
			class="sidebar-hot-zone"
			role="button"
			tabindex="0"
			aria-label="显示侧边栏"
			@mouseenter="showSidebarPreview"
			@focus="showSidebarPreview"
			@click="showSidebarPreview"
			@keydown.enter.prevent="showSidebarPreview"
			@keydown.space.prevent="showSidebarPreview"></div>
		  <el-container class="main-shell">
		    <el-header>
				<div class="a-header">
					<button
					  v-if="isMobile"
					  type="button"
					  class="mobile-menu-button"
					  :aria-expanded="String(mobileSidebarOpen)"
					  aria-controls="mobile-primary-navigation"
					  aria-label="打开导航菜单"
					  @click="mobileSidebarOpen = true">
						<i class="el-icon-menu"></i>
					</button>
					<div v-if="isMobile" class="mobile-header-title">智能叠光控制系统</div>
					<div class="a-header-left">
						<div><a href="https://www.kaihaikeji.com/user/login/?redirect=%2Fhome" target="_blank" style="text-decoration: none">智慧能源综合管理系统</a></div>
						<div><a href="https://www.kayhst.com/#/login" style="text-decoration: none" target="_blank">智能门禁管理系统</a></div>
						<div><a href="https://www.hxszkj.cn/login" style="text-decoration: none" target="_blank">智能动环管理系统</a></div>
					</div>
					<div class="header-right">
						<div
						  v-if="userLevel !== 1"
						  class="feedback-entry"
						  title="提交反馈"
						  aria-label="提交反馈"
						  role="button"
						  tabindex="0"
						  @click="openFeedback"
						  @keydown.enter.prevent="openFeedback"
						  @keydown.space.prevent="openFeedback">
							<i class="el-icon-chat-dot-square"></i>
						</div>
						<div class="log-popover">
							<el-popover placement="top-start" :width="isMobile ? 288 : 580" trigger="click">
								<div class="log-content">
									<div class="log-title">
										<div>登录时间</div>
										<div>账号</div>
										<div>登录地点</div>
										<div>登录IP</div>
									</div>
									<div v-for="(item,index) in loginList" :key="index" class="log-item">
										<div>{{item.createTime}}</div>
										<div>{{item.loginUserName}}</div>
										<div>{{item.loginCity}}</div>
										<div>{{item.loginIp}}</div>
									</div>
								</div>
								<i slot="reference" class="el-icon-tickets"></i>
								<div class="log-dot" v-if="loginList.length > 0"></div>
							</el-popover>
						</div>
						<div class="current-time">{{ currentTimeText }}</div>
						<div class="user-info">
							<el-popover placement="bottom" :trigger="isMobile ? 'click' : 'hover'">
							  <div class="user-pop-item" @click="$router.push({name:'indexVue'})">首页</div>
							  <div class="user-pop-item" @click="loadUserInfo();showEditUser = true;">个人信息</div>
							  <div class="user-pop-item" @click="loginOut();">退出登录</div>
							  <img
							    slot="reference"
								:src="headerAvatarUrl"
								alt="用户头像"
								@error="headerAvatarLoadFailed = true"/>
							</el-popover>
							<span class="user-name">{{userObject.userName}}</span>
						</div>
					</div>
				</div>
			</el-header>
		    <el-main>
				<el-collapse-transition>
					<router-view></router-view>
				</el-collapse-transition>
			</el-main>
		  </el-container>
		</el-container>

		<el-dialog
		  :visible.sync="showEditUser"
		  width="720px"
		  custom-class="account-info-dialog">
		  <div slot="title" class="account-dialog-title">
			  <strong>账号信息编辑</strong>
		  </div>
		  <div class="edit-form">
			  <div class="profile-panel">
				  <div class="avatar-section">
					  <div class="avatar-section__label">个人头像</div>
					  <el-upload
					    class="avatar-uploader"
					    :class="{'is-uploading': avatarUploading}"
						action="#"
					    :show-file-list="false"
						accept=".jpg,.jpeg,.png,image/jpeg,image/png"
						:http-request="handleAvatarUpload"
						:before-upload="beforeAvatarUpload"
						:disabled="avatarUploading">
					    <img v-if="userObject.picUrl" :src="userObject.picUrl" class="avatar">
					    <div v-else class="avatar-placeholder">
							<i class="el-icon-user-solid"></i>
							<span>添加头像</span>
						</div>
						<div class="avatar-mask">
							<i :class="avatarUploading ? 'el-icon-loading' : 'el-icon-camera-solid'"></i>
							<span>{{ avatarUploading ? '正在上传' : '更换头像' }}</span>
						</div>
					  </el-upload>
					  <div class="avatar-tip">支持 JPG / JPEG / PNG，文件不超过 2 MB</div>
				  </div>

				  <el-form :model="userObject" class="form-content" label-position="top">
					  <div class="form-grid">
						  <el-form-item label="名称">
							  <el-input v-model="userObject.userName" placeholder="请输入名称" prefix-icon="el-icon-user"/>
						  </el-form-item>
						  <el-form-item label="用户名">
							  <el-input v-model="userObject.account" placeholder="请输入用户名" prefix-icon="el-icon-s-custom"/>
						  </el-form-item>
						  <el-form-item label="手机号">
							  <el-input v-model="userObject.userMobile" placeholder="请输入手机号" prefix-icon="el-icon-mobile-phone"/>
						  </el-form-item>
						  <el-form-item label="邮箱">
							  <el-input v-model="userObject.userEmail" placeholder="请输入邮箱" prefix-icon="el-icon-message"/>
						  </el-form-item>
						  <el-form-item label="原密码">
							  <el-input v-model="userObject.userOldPass" type="password" show-password autocomplete="current-password" placeholder="请输入原密码" prefix-icon="el-icon-lock"/>
						  </el-form-item>
						  <el-form-item label="新密码">
							  <el-input v-model="userObject.userNewPass" type="password" show-password autocomplete="new-password" placeholder="请输入新密码" prefix-icon="el-icon-key"/>
						  </el-form-item>
					  </div>
				  </el-form>
			  </div>
			  <div class="form-btn">
				  <div>
					  <el-button @click="showEditUser = false;">取消</el-button>
					  <el-button type="primary" icon="el-icon-check" :disabled="avatarUploading" @click="subUserEdit();">保存修改</el-button>
				  </div>
			  </div>
		  </div>
		</el-dialog>
		<feedback-dialog :visible.sync="showFeedbackDialog" />
	</div>
</template>

<script>
	import FeedbackDialog from '../feedback/index.vue';
	import { getAccountPermission } from '../../utils/accountPermission';

	export default {
		components: {
			FeedbackDialog
		},
	    data() {
		  return {
			  loginList:[],        // 登录日志 - 核心保留
			  currentTimeText: '', // 实时时间 - 核心保留
			  showEditUser:false,  // 个人编辑弹窗 - 核心保留
			  userObject:{},       // 用户信息 - 核心保留
			  currentUrl:"indexVue",// 菜单激活 - 核心保留
			  avatarUploading:false,
			  headerAvatarLoadFailed:false,
			  defaultAvatar:require('../../../static/27.png'),
			  // 用户级别控制（从本地存储读取）
			  userLevel:2,
			  canEdit:1,
			  sidebarPinned:true,
			  sidebarPreviewVisible:false,
			  sidebarResizeTimer:null,
			  currentTimeTimer:null,
			  isMobile:false,
			  mobileSidebarOpen:false,
			  mobileMediaQuery:null,
			  showFeedbackDialog:false
		  }
		},
		computed: {
			sidebarVisible() {
				return this.isMobile ? this.mobileSidebarOpen : (this.sidebarPinned || this.sidebarPreviewVisible);
			},
			sidebarWidth() {
				return !this.isMobile && this.sidebarPinned ? '256px' : '0px';
			},
			sidebarToggleTitle() {
				if (this.isMobile) return '关闭导航菜单';
				return this.sidebarPinned ? '隐藏侧边栏' : '固定侧边栏';
			},
			headerAvatarUrl() {
				return !this.headerAvatarLoadFailed && this.userObject.picUrl
					? this.userObject.picUrl
					: this.defaultAvatar;
			}
		},
		mounted() {
			document.title='智能叠光控制系统';
			this.mobileMediaQuery = window.matchMedia('(max-width: 760px)');
			this.handleMobileMediaChange(this.mobileMediaQuery);
			if (this.mobileMediaQuery.addEventListener) {
				this.mobileMediaQuery.addEventListener('change', this.handleMobileMediaChange);
			} else {
				this.mobileMediaQuery.addListener(this.handleMobileMediaChange);
			}
			window.addEventListener('keydown', this.handleGlobalKeydown);
			this.sidebarPinned = localStorage.getItem('solar-energy-sidebar-pinned') !== 'false';
			// 读取用户级别缓存
			this.userLevel = Number(localStorage.getItem("a-xny-level")) || 2;
			this.canEdit = getAccountPermission();
			
			// 🔥 核心修复：区分首次登录和刷新场景
			// 场景1：首次登录进入homeVue，且当前路由是根路径/ → 跳首页
			if (this.$route.path === '/') {
				this.$router.push({name:'indexVue'});
			}
			// 场景2：刷新子页面（如/powerAnaly）→ 不跳转，仅匹配菜单激活状态
			else if (this.$route.name) {
				this.currentUrl = this.$route.name;
			}
			
			// 加载核心数据 - 保留
			this.loadUserInfo();
			this.loadLoginList();
			this.currentTime();
			this.currentTimeTimer = setInterval(this.currentTime, 1000);
		},
		beforeDestroy() {
			if (this.sidebarResizeTimer) clearTimeout(this.sidebarResizeTimer);
			if (this.currentTimeTimer) clearInterval(this.currentTimeTimer);
			window.removeEventListener('keydown', this.handleGlobalKeydown);
			if (this.mobileMediaQuery) {
				if (this.mobileMediaQuery.removeEventListener) {
					this.mobileMediaQuery.removeEventListener('change', this.handleMobileMediaChange);
				} else {
					this.mobileMediaQuery.removeListener(this.handleMobileMediaChange);
				}
			}
		},
		watch: {
			'$route.name'() {
				this.closeMobileSidebar();
			}
		},
		methods: {
			handleMobileMediaChange(event) {
				this.isMobile = Boolean(event.matches);
				if (!this.isMobile) this.mobileSidebarOpen = false;
				this.$nextTick(this.notifyLayoutResize);
			},
			handleGlobalKeydown(event) {
				if (event.key === 'Escape') this.closeMobileSidebar();
			},
			closeMobileSidebar() {
				if (this.mobileSidebarOpen) this.mobileSidebarOpen = false;
			},
			handleMenuSelect(index) {
				this.currentUrl = index;
				this.closeMobileSidebar();
			},
			handleSidebarToggle() {
				if (this.isMobile) {
					this.closeMobileSidebar();
					return;
				}
				this.toggleSidebarPin();
			},
			openFeedback() {
				this.showFeedbackDialog = true;
			},
			showSidebarPreview() {
				if (!this.sidebarPinned) this.sidebarPreviewVisible = true;
			},
			handleSidebarMouseEnter() {
				if (!this.sidebarPinned) this.sidebarPreviewVisible = true;
			},
			handleSidebarMouseLeave() {
				if (!this.sidebarPinned) this.sidebarPreviewVisible = false;
			},
			toggleSidebarPin() {
				this.sidebarPinned = !this.sidebarPinned;
				this.sidebarPreviewVisible = false;
				localStorage.setItem('solar-energy-sidebar-pinned', String(this.sidebarPinned));
				this.notifyLayoutResize();
			},
			notifyLayoutResize() {
				if (this.sidebarResizeTimer) clearTimeout(this.sidebarResizeTimer);
				this.sidebarResizeTimer = setTimeout(() => {
					window.dispatchEvent(new Event('resize'));
				}, 300);
			},
			// 加载登录日志 - 核心功能，保留
			loadLoginList() {
				this.$request.get('/api/login/history/list').then(response => {
					if(response.data.result) {
						this.loginList = response.data.data;
					}
				})
			},
			// 实时时间格式化 - 核心功能，保留
			currentTime() {
			    var date = new Date();
			    var year = date.getFullYear();
			    var dateArr = [
			        date.getMonth() + 1,
			        date.getDate(),
			        date.getHours(),
			        date.getMinutes(),
			        date.getSeconds(),
			    ];
			    // 补0格式化
			    for (var i = 0; i < dateArr.length; i++) {
			        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
			            dateArr[i] = "0" + dateArr[i];
			        }
			    }
			    this.currentTimeText = `${year}-${dateArr[0]}-${dateArr[1]} ${dateArr[2]}:${dateArr[3]}:${dateArr[4]}`;
			},
			// 个人信息提交 - 核心业务，保留
			subUserEdit() {
				if(!this.userObject.userName) return this.$message.error('名称不能为空!');
				if(!this.userObject.account) return this.$message.error('用户名不能为空!');
				if(!this.userObject.userMobile) return this.$message.error('手机号不能为空!');
				if(!this.userObject.userNewPass) return this.$message.error('新密码不能为空!');
				if(!this.userObject.userOldPass) return this.$message.error('原密码不能为空!');
				if(!this.userObject.picUrl) return this.$message.error('请上传头像!');
				
				this.$request.post('/api/user/modify',this.userObject).then(response => {
					if(response.data.result) {
						this.$message.success("修改成功");
						this.showEditUser = false;
					} else {
						this.$message.error(response.data.message);
					}
				})
			},
			// 头像上传：申请预签名地址，直传对象存储，再通知服务端完成业务处理
			async handleAvatarUpload(uploadRequest) {
				const file = uploadRequest.file;
				const contentType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';
				this.avatarUploading = true;
				try {
					const presignResponse = await this.$request.post('/api/upload/presign', {
						businessType: 'USER_AVATAR',
						businessId: this.userObject.id || undefined,
						fileName: file.name,
						contentType: contentType,
						fileSize: file.size
					});
					if (!presignResponse.data.result || !presignResponse.data.data) {
						throw new Error(presignResponse.data.message || '获取头像上传地址失败');
					}

					const uploadTask = presignResponse.data.data;
					const putResponse = await fetch(uploadTask.uploadUrl, {
						method: 'PUT',
						headers: uploadTask.requiredHeaders || {'Content-Type': contentType},
						body: file,
						credentials: 'omit'
					});
					if (!putResponse.ok) {
						throw new Error('对象存储上传失败（HTTP ' + putResponse.status + '）');
					}

					const completeResponse = await this.$request.post('/api/upload/complete', {
						taskNo: uploadTask.taskNo
					});
					const completeResult = completeResponse.data.data;
					if (!completeResponse.data.result || !completeResult) {
						throw new Error(completeResponse.data.message || '头像上传完成确认失败');
					}
					if (completeResult.status !== 'SUCCESS' || !completeResult.previewUrl) {
						throw new Error('头像处理未完成，请稍后重试');
					}

					this.$set(this.userObject, 'picUrl', completeResult.previewUrl);
					this.headerAvatarLoadFailed = false;
					this.$message.success('头像上传成功');
					if (uploadRequest.onSuccess) uploadRequest.onSuccess(completeResult);
				} catch (error) {
					const responseMessage = error && error.response && error.response.data && error.response.data.message;
					const message = responseMessage || (error && error.message) || '头像上传失败，请稍后重试';
					this.$message.error(message);
					if (uploadRequest.onError) uploadRequest.onError(error);
				} finally {
					this.avatarUploading = false;
				}
			},
			// 头像上传校验 - 核心功能，保留
			beforeAvatarUpload(file) {
				const isSupportedImage = file.type === 'image/jpeg' || file.type === 'image/png';
				const isLt2M = file.size <= 2 * 1024 * 1024;
					
				if (!isSupportedImage) this.$message.error('上传头像仅支持 JPG、JPEG 或 PNG 格式!');
				if (!isLt2M) this.$message.error('上传头像图片大小不能超过 2MB!');
			    return isSupportedImage && isLt2M;
			},
			// 加载用户信息 - 核心功能，保留
			loadUserInfo() {
				this.$request.get('/api/user/info').then(response => {
					if(response.data.result) {
						this.userObject = response.data.data;
						this.headerAvatarLoadFailed = false;
					} else {
						this.$message.error("获取用户信息失败,请联系管理员!");
					}
				})
			},
			// 退出登录 - 核心功能，保留
			loginOut() {
				// 清空缓存
				localStorage.setItem("a-xny-token",'');
				localStorage.setItem("a-xny-userName",'');
				localStorage.setItem("a-xny-level",'');
				localStorage.removeItem("a-xny-can-edit");
				// 跳转到登录页
				this.$router.push({name:'login'});
			},
			// 菜单展开/收起 - 保留（菜单核心交互）
			handleOpen(key, keyPath) {
				this.currentUrl = keyPath;
			},
			handleClose() {}
		}
	}
</script>

<!-- 全局样式 - 完全未改动 -->
<style>
	/* 全局重置 - 统一深色风格 */
	body, .el-container {
    background-color: #001A33 !important;
    color: #87CEFA !important;
    margin: 0;
    padding: 0;
	}
	/* 弹窗样式 - 匹配项目风格 */
	.account-info-dialog.el-dialog {
		margin-top: 8vh !important;
		margin-bottom: 4vh;
		border: 1px solid rgba(63, 184, 255, 0.52);
		border-radius: 12px;
		background: linear-gradient(145deg, rgba(0, 43, 77, 0.98), rgba(0, 20, 42, 0.99));
		box-shadow: 0 24px 70px rgba(0, 6, 20, 0.58), inset 0 1px 0 rgba(176, 226, 255, 0.13);
		overflow: hidden;
	}
	.account-info-dialog .el-dialog__header {
		padding: 20px 24px;
		border-bottom: 1px solid rgba(63, 184, 255, 0.24);
		background: linear-gradient(90deg, rgba(0, 76, 122, 0.45), rgba(0, 26, 51, 0.3));
	}
	.account-info-dialog .el-dialog__headerbtn {
		top: 23px;
		right: 24px;
	}
	.account-info-dialog .el-dialog__headerbtn .el-dialog__close {
		color: #8edcf7;
		font-size: 18px;
	}
	.account-info-dialog .el-dialog__headerbtn:hover .el-dialog__close {color: #ffffff;}
	.account-info-dialog .el-dialog__body {
		padding: 0;
		color: #d7f6ff;
	}
	.account-info-dialog .el-input {
		border: 0 !important;
		background: transparent !important;
	}
	.account-info-dialog .el-input__inner {
		height: 40px;
		border: 1px solid rgba(63, 184, 255, 0.34) !important;
		border-radius: 6px;
		background: rgba(0, 18, 36, 0.7) !important;
		color: #e9fbff !important;
		transition: border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
	}
	.account-info-dialog .el-input__inner:hover {border-color: rgba(63, 184, 255, 0.68) !important;}
	.account-info-dialog .el-input__inner:focus {border-color: #00bfff !important; background: rgba(0, 31, 61, 0.82) !important; box-shadow: 0 0 0 3px rgba(0, 191, 255, 0.11);}
	.account-info-dialog .el-input__prefix {color: #55c8f2;}
	.account-info-dialog .el-input__suffix {color: #75cfea;}
	.account-info-dialog .el-form-item__label {padding: 0 0 7px; color: #a8dff1; font-size: 13px; font-weight: 600; line-height: 18px;}
	.account-info-dialog .el-form-item {margin-bottom: 17px;}
	.account-info-dialog .avatar-uploader .el-upload {display: block; width: 132px; height: 132px; line-height: normal; border: 2px solid rgba(0, 191, 255, 0.66); border-radius: 50%; background: rgba(0, 18, 36, 0.76); box-shadow: 0 0 0 7px rgba(0, 153, 255, 0.08), 0 12px 28px rgba(0, 8, 22, 0.32);}
	.account-info-dialog .avatar-uploader .el-upload:hover {border-color: #8ee9ff; box-shadow: 0 0 0 7px rgba(0, 191, 255, 0.12), 0 14px 34px rgba(0, 8, 22, 0.42);}
	.account-info-dialog .el-button {min-width: 94px; height: 38px; border-radius: 6px; font-weight: 600;}
	.account-info-dialog .el-button--primary {background: linear-gradient(135deg, #0099ff, #00c8e8) !important; box-shadow: 0 8px 18px rgba(0, 153, 255, 0.23);}
	.account-info-dialog .el-button--primary:hover {background: linear-gradient(135deg, #20a9ff, #18d5ee) !important; transform: translateY(-1px);}
	@media (max-width: 760px) {
		.account-info-dialog.el-dialog {width: calc(100% - 24px) !important; margin-top: 2vh !important;}
	}
	.el-popover{
		min-width: 90px !important;
		padding: 0 !important;
		background-color: #002B4D !important;
		border: 1px solid #0099FF !important;
		color: #87CEFA !important;
	}
	/* 头像上传组件 - 核心样式保留 */
	.avatar-uploader .el-upload {
	    border: 1px dashed #0099FF;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	    background-color: #001A33;
	    width: 178px;
	    height: 178px;
	    line-height: 178px;
	    text-align: center;
	}
	.avatar-uploader .el-upload:hover {border-color: #87CEFA;}
	.avatar-uploader-icon {font-size: 28px; color: #0099FF;}
	.avatar {width: 178px; height: 178px; display: block;}
	/* 全局表单/按钮样式 - 匹配深色风格 */
	.el-input__inner {background-color: #002B4D !important; border: 1px solid #0099FF !important; color: #87CEFA !important;}
	.el-button {background-color: #002B4D !important; border: 1px solid #0099FF !important; color: #87CEFA !important;}
	.el-button--primary {background-color: #0099FF !important; border: none !important; color: #fff !important;}
	.el-popover {
		border-radius: 8px !important;
		background:
			linear-gradient(180deg, rgba(0, 43, 77, 0.98), rgba(0, 26, 51, 0.98)) !important;
		border-color: rgba(0, 153, 255, 0.58) !important;
		box-shadow: 0 16px 34px rgba(0, 8, 22, 0.42), inset 0 1px 0 rgba(176, 226, 255, 0.12) !important;
	}
	.el-popover .popper__arrow,
	.el-popover .popper__arrow::after {
		border-top-color: rgba(0, 43, 77, 0.98) !important;
		border-bottom-color: rgba(0, 43, 77, 0.98) !important;
	}
</style>

<!-- 作用域样式 - 核心：一级/子菜单字体统一+强层级感 -->
<style scoped>
	/* 侧边栏标题样式 - 保留原有科技感 */
	.a-left {display: flex; flex-direction: column; width: 100%; height: 100%; max-height: 100%; overflow: hidden; background-color: #001A33;}
	.a-main-1 {
    color: #0099FF; 
    font-size: 18px; 
    text-align: center; 
    line-height: 66px; 
    background-color: #001A33; 
    margin: 0;
    font-family: "Consolas", "Microsoft YaHei", "SimHei", "PingFang SC", sans-serif;
    font-weight: 700;
    letter-spacing: 2px;
    text-shadow: 0 0 5px rgba(0, 153, 255, 0.7);
	}
	.a-left-menu {
		flex: 1 1 auto;
		min-height: 0;
		overflow-x: hidden;
		overflow-y: auto;
		padding: 5px 0;
	}
	.a-left-menu::-webkit-scrollbar {width: 6px;}
	.a-left-menu::-webkit-scrollbar-button,
	.a-left-menu::-webkit-scrollbar-button:single-button,
	.a-left-menu::-webkit-scrollbar-button:vertical:decrement,
	.a-left-menu::-webkit-scrollbar-button:vertical:increment {
		display: block !important;
		width: 0 !important;
		height: 0 !important;
		min-height: 0 !important;
		-webkit-appearance: none;
		appearance: none;
		background: transparent !important;
	}
	.a-left-menu::-webkit-scrollbar-track {background: rgba(0, 21, 42, 0.45);}
	.a-left-menu::-webkit-scrollbar-thumb {border-radius: 3px; background: rgba(0, 204, 255, 0.58);}
	.a-left-menu::-webkit-scrollbar-thumb:hover {background: rgba(128, 232, 255, 0.82);}

	/* 顶部/弹窗/表单等非侧边栏样式 - 完全未动 */
	.a-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 56px;
		line-height: normal;
		padding: 0 22px 0 18px;
		background:
			linear-gradient(180deg, rgba(0, 60, 102, 0.82) 0%, rgba(0, 26, 51, 0.94) 100%),
			radial-gradient(circle at 18% 0%, rgba(0, 204, 255, 0.2), transparent 35%);
		border-bottom: 1px solid rgba(0, 153, 255, 0.52);
		box-shadow: inset 0 -1px 0 rgba(176, 226, 255, 0.16), 0 10px 24px rgba(0, 10, 24, 0.34);
		color: #d7f6ff;
		box-sizing: border-box;
		position: relative;
		z-index: 3;
	}
	.a-header::after {
		content: "";
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		height: 1px;
		background: linear-gradient(90deg, transparent, rgba(0, 204, 255, 0.72), transparent);
		pointer-events: none;
	}
	.a-header a {color: inherit !important; text-decoration: none;}
	.a-header-left {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		height: 38px;
		padding: 3px;
		border: 1px solid rgba(0, 153, 255, 0.28);
		border-radius: 6px;
		background: rgba(0, 26, 51, 0.36);
		box-shadow: inset 0 0 18px rgba(0, 153, 255, 0.08);
	}
	.a-header-left > div {display: flex; align-items: center;}
	.a-header-left a {
		display: flex;
		align-items: center;
		height: 30px;
		padding: 0 16px;
		border: 1px solid transparent;
		border-radius: 4px;
		background: transparent;
		color: #b0e2ff !important;
		font-size: 13px;
		font-weight: 600;
		letter-spacing: 0;
		transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
		white-space: nowrap;
	}
	.a-header-left a:hover {
		transform: translateY(-1px);
		border-color: rgba(0, 204, 255, 0.58);
		background: linear-gradient(180deg, rgba(0, 153, 255, 0.26), rgba(0, 60, 102, 0.3));
		box-shadow: inset 0 0 14px rgba(0, 204, 255, 0.12), 0 4px 12px rgba(0, 10, 24, 0.2);
		color: #ffffff !important;
	}
	.header-right {
		display: flex;
		align-items: center;
		gap: 10px;
		position: relative;
		flex-shrink: 0;
	}
	.current-time {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 204px;
		height: 32px;
		padding: 0 12px;
		border: 1px solid rgba(0, 153, 255, 0.28);
		border-radius: 4px;
		background: rgba(0, 26, 51, 0.3);
		color: #bdeeff;
		font-size: 13px;
		font-family: Consolas, "Microsoft YaHei", sans-serif;
		box-shadow: inset 0 0 12px rgba(0, 153, 255, 0.08);
		box-sizing: border-box;
		text-align: center;
		white-space: nowrap;
	}
	.log-popover,
	.feedback-entry {position: relative; display: flex; align-items: center;}
	.log-popover .el-icon-tickets,
	.feedback-entry .el-icon-chat-dot-square {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 32px;
		height: 32px;
		border: 1px solid rgba(0, 153, 255, 0.4);
		border-radius: 4px;
		background: rgba(0, 153, 255, 0.12);
		color: #b0e2ff;
		font-size: 17px;
		cursor: pointer;
		transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
	}
	.log-popover .el-icon-tickets:hover,
	.feedback-entry .el-icon-chat-dot-square:hover {
		transform: translateY(-1px);
		border-color: rgba(0, 204, 255, 0.78);
		background: rgba(0, 153, 255, 0.24);
		box-shadow: 0 0 12px rgba(0, 204, 255, 0.18);
		color: #ffffff;
	}
	.user-info {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 8px;
		min-width: 136px;
		height: 32px;
		padding: 0 12px;
		border: 1px solid rgba(0, 153, 255, 0.36);
		border-radius: 4px;
		background: rgba(0, 26, 51, 0.34);
		box-shadow: inset 0 0 12px rgba(0, 153, 255, 0.08);
		box-sizing: border-box;
		font-size: 13px;
	}
	.user-info .el-popover__reference-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		flex: 0 0 22px;
		width: 22px;
		height: 22px;
		line-height: 0;
	}
	.user-info img {display: block; width: 22px !important; height: 22px !important; margin: 0 !important; border-radius: 50%; border: 1px solid rgba(0, 204, 255, 0.55); background: rgba(0, 18, 36, 0.76); box-shadow: 0 0 10px rgba(0, 204, 255, 0.14); box-sizing: border-box; object-fit: contain;}
	.user-name {display: flex; align-items: center; justify-content: center; max-width: 96px; height: 22px; overflow: hidden; color: #d7f6ff; line-height: 22px; text-overflow: ellipsis; white-space: nowrap;}
	.log-content {padding: 20px; height: 200px; overflow-y: auto; width: 100%; box-sizing: border-box;}
	.log-title {display: flex;}
	.log-title > div {width: 30%; flex: 1;}
	.log-item {display: flex; border-bottom: 1px solid rgba(0,0,0,.12); height: 42px; line-height: 42px;}
	.log-item > div {width: 30%; flex: 1;}
	.log-dot {width: 8px; height: 8px; background: #FF9A2B; border-radius: 50%; position: absolute; top: 10px; left: 18px;}
	.user-pop-item {text-align: center; cursor: pointer; font-size: 14px; width: 90px; height: 40px; line-height: 40px; background-color: #001A33; color: #87CEFA;}
	.user-pop-item:hover {background-color: #002B4D; color: #B0E2FF; border-bottom: 1px solid #002B4D;}
	.account-dialog-title {padding-right: 40px; text-align: left;}
	.account-dialog-title strong {display: block; color: #f2fcff; font-size: 17px; line-height: 38px; letter-spacing: 0.5px;}
	.edit-form {width: 100%; box-sizing: border-box; text-align: left;}
	.profile-panel {display: grid; grid-template-columns: 184px minmax(0, 1fr); gap: 26px; padding: 26px 28px 20px;}
	.avatar-section {display: flex; flex-direction: column; align-items: center; padding: 18px 16px; border: 1px solid rgba(63, 184, 255, 0.22); border-radius: 9px; background: linear-gradient(180deg, rgba(0, 58, 94, 0.42), rgba(0, 18, 36, 0.38));}
	.avatar-section__label {align-self: flex-start; margin-bottom: 23px; color: #a8dff1; font-size: 13px; font-weight: 600;}
	.avatar-uploader {width: 132px; height: 132px; border-radius: 50%;}
	.avatar {width: 132px; height: 132px; display: block; border-radius: 50%; background: rgba(0, 18, 36, 0.76); object-fit: contain;}
	.avatar-placeholder {display: flex; flex-direction: column; align-items: center; justify-content: center; width: 132px; height: 132px; color: #62c8eb;}
	.avatar-placeholder i {margin-bottom: 8px; font-size: 36px;}
	.avatar-placeholder span {font-size: 12px;}
	.avatar-mask {position: absolute; inset: 0; display: flex; flex-direction: column; align-items: center; justify-content: center; border-radius: 50%; background: rgba(0, 14, 30, 0.74); color: #effcff; opacity: 0; transition: opacity 0.2s ease;}
	.avatar-mask i {margin-bottom: 7px; font-size: 22px;}
	.avatar-mask span {font-size: 12px; font-weight: 600;}
	.avatar-uploader:hover .avatar-mask, .avatar-uploader.is-uploading .avatar-mask {opacity: 1;}
	.avatar-tip {margin-top: 18px; color: #6faec8; font-size: 11px; line-height: 18px; text-align: center;}
	.form-content {width: 100%; margin: 0; text-align: left;}
	.form-grid {display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); column-gap: 18px;}
	.form-btn {display: flex; align-items: center; justify-content: flex-end; min-height: 68px; padding: 14px 28px; border-top: 1px solid rgba(63, 184, 255, 0.2); background: rgba(0, 18, 36, 0.34); box-sizing: border-box;}
	.form-btn .el-button + .el-button {margin-left: 10px;}
	@media (max-width: 760px) {
		.profile-panel {grid-template-columns: 1fr; padding: 20px;}
		.avatar-section {padding-bottom: 16px;}
		.avatar-section__label {align-self: center; margin-bottom: 18px;}
		.form-grid {grid-template-columns: 1fr;}
		.form-btn {align-items: stretch; flex-direction: column; gap: 12px;}
		.form-btn > div {display: flex; justify-content: flex-end;}
	}

	/* ElementUI菜单核心样式 - 一级/子菜单字体统一+层级区分 */
	/deep/.home-aside {height: 100% !important; max-height: 100% !important; overflow: visible !important; background-color: #001A33 !important; padding: 0 !important; margin: 0 !important; border-right: none !important; box-shadow: none; position: relative;}
	/deep/.home-aside::after {
		content: "";
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		width: 1px;
		background: #3fb8ff;
		box-shadow: 1px 0 0 rgba(176, 226, 255, 0.3);
		pointer-events: none;
	}
	/deep/.el-menu {
		background-color: #001A33 !important; 
		border-right: none !important; 
		/* 所有菜单统一字体库，保证样式一致 */
		font-family: "Consolas", "Microsoft YaHei", "SimHei", "PingFang SC", sans-serif;
	}
	/* 1. 一级菜单（平台首页/监测管理/设备信息/告警列表等）专属样式 - 醒目主层级 */
	/deep/.el-menu-item:not(.el-submenu .el-menu-item), /deep/.el-submenu__title {
		height: 56px !important;
		line-height: 56px !important;
		padding: 0 25px !important; /* 一级菜单左内边距稍大，更醒目 */
		color: #00e1ff !important;   /* 亮青色，主层级视觉突出 */
		font-size: 15px !important;  /* 一号字，比子菜单大 */
		font-weight: 700 !important; /* 加粗，强化主层级 */
		letter-spacing: 1.2px !important; /* 轻微字间距，科技感 */
		text-shadow: 0 0 4px rgba(0, 225, 255, 0.4) !important; /* 轻发光，提升质感 */
	}
	/* 一级菜单hover/激活 - 强化交互反馈 */
	/deep/.el-menu-item:not(.el-submenu .el-menu-item):hover, /deep/.el-submenu__title:hover {
		background-color: #002B4D !important;
		color: #ffffff !important;
		text-shadow: 0 0 6px rgba(0, 225, 255, 0.8) !important;
	}
	/deep/.el-menu-item:not(.el-submenu .el-menu-item).is-active, /deep/.el-submenu.is-active .el-submenu__title {
		background-color: #002B4D !important;
		color: #ffffff !important;
		text-shadow: 0 0 6px rgba(0, 225, 255, 0.8) !important;
	}

	/* 2. 子菜单（展开后的电站列表/设备监测等）专属样式 - 从属次层级，和一级字体统一但有明显区分 */
	/deep/.el-submenu .el-menu-item {
		height: 50px !important;
		line-height: 50px !important;
		padding: 0 50px !important; /* 大幅缩进，直观区分层级 */
		color: #74d0ff !important;  /* 浅青色，比一级菜单淡，从属关系明显 */
		font-size: 14px !important; /* 二号字，比一级小1px */
		font-weight: 500 !important;/* 常规字重，低于一级菜单 */
		letter-spacing: 1px !important; /* 字间距稍小，和一级区分 */
		background-color: rgba(0, 43, 77, 0.2) !important; /* 浅背景层，视觉隔离 */
		/* 子菜单也用统一字体库，保证样式协调 */
		font-family: "Consolas", "Microsoft YaHei", "SimHei", "PingFang SC", sans-serif;
	}
	/* 子菜单hover/激活 - 交互一致，层级不越界 */
	/deep/.el-submenu .el-menu-item:hover {
		background-color: #002B4D !important;
		color: #e0f7ff !important;
		font-weight: 600 !important; /* hover仅轻加粗，不超过一级菜单 */
	}
	/deep/.el-submenu .el-menu-item.is-active {
		background-color: #002B4D !important;
		color: #e0f7ff !important;
		font-weight: 600 !important; /* 激活加粗度低于一级，保留层级 */
	}

	/* 菜单箭头样式 - 匹配一级菜单颜色 */
	/deep/.el-submenu__icon-arrow {
		color: #00e1ff !important;
		font-size: 12px !important;
	}
	/* 容器基础样式 - 完全未动 */
	/deep/.el-container, /deep/.el-main {background-color: #001A33 !important; padding: 0 !important;}
	.home-page,
	.home-layout {
		height: 100%;
		max-height: 100%;
		min-height: 0;
		overflow: hidden;
	}
	/deep/.main-shell {
		height: 100% !important;
		max-height: 100% !important;
		min-height: 0 !important;
		overflow: hidden !important;
	}
	/deep/.main-shell > .el-main {
		flex: 1 1 auto !important;
		height: auto !important;
		max-height: none !important;
		min-height: 0 !important;
		overflow: hidden !important;
	}
	/deep/.el-header {padding: 0 !important;}

	.home-page {
		position: relative;
		background:
			radial-gradient(circle at 62% 0%, rgba(0, 204, 255, 0.12), transparent 30%),
			linear-gradient(180deg, #001A33 0%, #001326 100%) !important;
		font-family: "HarmonyOS Sans SC", "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", Arial, sans-serif;
	}
	.home-page::before {
		content: "";
		position: absolute;
		inset: 0;
		pointer-events: none;
		background-image:
			linear-gradient(rgba(0, 153, 255, 0.045) 1px, transparent 1px),
			linear-gradient(90deg, rgba(0, 153, 255, 0.045) 1px, transparent 1px);
		background-size: 42px 42px;
		opacity: 0.58;
	}
	.home-layout {
		position: relative;
		z-index: 1;
	}
	/deep/.home-aside {
		flex: 0 0 auto;
		z-index: 30;
		transition: transform 0.26s ease, box-shadow 0.26s ease;
		will-change: transform;
	}
	/deep/.home-aside.is-floating {
		position: absolute !important;
		top: 0;
		bottom: 0;
		left: 0;
		width: 256px !important;
		transform: translateX(-100%);
		visibility: hidden;
		transition: transform 0.26s ease, box-shadow 0.26s ease, visibility 0s linear 0.26s;
	}
	/deep/.home-aside.is-floating.is-preview-visible {
		transform: translateX(0);
		visibility: visible;
		box-shadow: 18px 0 42px rgba(0, 8, 22, 0.58), 1px 0 0 rgba(0, 204, 255, 0.42);
		transition-delay: 0s;
	}
	.sidebar-pin-button {
		position: absolute;
		top: 50%;
		right: -14px;
		z-index: 3;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 54px;
		padding: 0;
		border: 1px solid rgba(0, 204, 255, 0.72);
		border-radius: 0 8px 8px 0;
		outline: none;
		background: linear-gradient(180deg, rgba(0, 76, 122, 0.98), rgba(0, 34, 62, 0.98));
		color: #b9efff;
		box-shadow: 5px 0 16px rgba(0, 8, 22, 0.38), inset 0 0 10px rgba(0, 204, 255, 0.08);
		cursor: pointer;
		transform: translateY(-50%);
		transition: width 0.18s ease, color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
	}
	.sidebar-pin-button:hover,
	.sidebar-pin-button:focus-visible {
		width: 32px;
		border-color: #80e8ff;
		color: #ffffff;
		box-shadow: 6px 0 20px rgba(0, 153, 255, 0.3), inset 0 0 12px rgba(0, 204, 255, 0.14);
	}
	.sidebar-pin-button i {
		font-size: 15px;
		text-shadow: 0 0 8px rgba(0, 204, 255, 0.55);
	}
	.sidebar-hot-zone {
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		z-index: 20;
		width: 12px;
		outline: none;
		cursor: e-resize;
	}
	.sidebar-hot-zone::after {
		content: "";
		position: absolute;
		top: 35%;
		bottom: 35%;
		left: 0;
		width: 3px;
		border-radius: 0 3px 3px 0;
		background: rgba(0, 204, 255, 0.34);
		box-shadow: 0 0 10px rgba(0, 204, 255, 0.26);
		transition: width 0.18s ease, background-color 0.18s ease;
	}
	.sidebar-hot-zone:hover::after,
	.sidebar-hot-zone:focus::after {
		width: 5px;
		background: rgba(0, 204, 255, 0.82);
	}
	/deep/.main-shell {
		min-width: 0;
	}
	.a-left {
		position: relative;
		background:
			linear-gradient(180deg, rgba(0, 34, 62, 0.98), #001A33 42%, #001326 100%),
			radial-gradient(circle at 50% 4%, rgba(0, 204, 255, 0.16), transparent 28%) !important;
		box-shadow: inset -1px 0 0 rgba(0, 153, 255, 0.28);
	}
	.a-left::before {
		content: "";
		position: absolute;
		inset: 0;
		pointer-events: none;
		background: linear-gradient(90deg, rgba(0, 204, 255, 0.06), transparent 22%);
	}
	.a-main-1 {
		position: relative;
		height: 72px;
		line-height: 72px !important;
		color: #D7F6FF !important;
		background:
			linear-gradient(180deg, rgba(0, 60, 102, 0.72), rgba(0, 26, 51, 0.78)),
			radial-gradient(circle at 50% 0%, rgba(0, 204, 255, 0.22), transparent 56%) !important;
		font-family: "Bahnschrift", "DIN Alternate", "Microsoft YaHei UI", "Microsoft YaHei", sans-serif !important;
		font-size: 19px !important;
		font-weight: 700 !important;
		letter-spacing: 1px !important;
		text-shadow: 0 0 14px rgba(0, 204, 255, 0.46) !important;
		box-shadow: inset 0 -1px 0 rgba(0, 153, 255, 0.36);
	}
	.a-main-1::after {
		content: "";
		position: absolute;
		left: 28px;
		right: 28px;
		bottom: 10px;
		height: 2px;
		background: linear-gradient(90deg, transparent, #00CCFF, rgba(0, 153, 255, 0.26), transparent);
		box-shadow: 0 0 12px rgba(0, 204, 255, 0.5);
	}
	.a-left-menu {
		position: relative;
		padding: 12px 10px 10px !important;
	}
	/deep/.home-aside::after {
		background: linear-gradient(180deg, transparent, rgba(0, 204, 255, 0.78), transparent) !important;
		box-shadow: 0 0 16px rgba(0, 204, 255, 0.34) !important;
	}
	/deep/.el-menu {
		background: transparent !important;
	}
	/deep/.el-menu > .el-menu-item,
	/deep/.el-menu > .el-submenu > .el-submenu__title {
		position: relative;
		overflow: hidden;
		margin: 4px 0;
		border: 1px solid transparent;
		border-radius: 6px;
		color: #B0E2FF !important;
		font-family: "Microsoft YaHei UI", "Microsoft YaHei", "PingFang SC", sans-serif !important;
		font-size: 15px !important;
		font-weight: 700 !important;
		letter-spacing: 0 !important;
		text-shadow: 0 0 10px rgba(0, 204, 255, 0.22) !important;
		transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
	}
	/deep/.el-menu > .el-menu-item::before,
	/deep/.el-menu > .el-submenu > .el-submenu__title::before,
	/deep/.el-submenu .el-menu-item::before {
		content: "";
		position: absolute;
		left: 0;
		top: 12px;
		bottom: 12px;
		width: 3px;
		border-radius: 0 3px 3px 0;
		background: transparent;
		box-shadow: none;
		transition: background-color 0.2s ease, box-shadow 0.2s ease;
	}
	/deep/.el-menu > .el-menu-item:hover,
	/deep/.el-menu > .el-submenu > .el-submenu__title:hover {
		background: linear-gradient(90deg, rgba(0, 153, 255, 0.2), rgba(0, 43, 77, 0.32)) !important;
		border-color: rgba(0, 153, 255, 0.34);
		color: #FFFFFF !important;
		box-shadow: inset 0 0 18px rgba(0, 153, 255, 0.08);
	}
	/deep/.el-menu > .el-menu-item.is-active,
	/deep/.el-menu > .el-submenu.is-active > .el-submenu__title {
		background: linear-gradient(90deg, rgba(0, 153, 255, 0.32), rgba(0, 43, 77, 0.48)) !important;
		border-color: rgba(0, 204, 255, 0.52);
		color: #FFFFFF !important;
		box-shadow: inset 0 0 20px rgba(0, 153, 255, 0.16), 0 0 16px rgba(0, 153, 255, 0.12);
	}
	/deep/.el-menu > .el-menu-item.is-active::before,
	/deep/.el-menu > .el-submenu.is-active > .el-submenu__title::before,
	/deep/.el-submenu .el-menu-item.is-active::before {
		background: transparent;
		box-shadow: none;
	}
	/deep/.el-submenu .el-menu {
		padding: 2px 0 8px;
		background: rgba(0, 21, 42, 0.2) !important;
	}
	/deep/.el-submenu .el-menu-item {
		position: relative;
		margin: 2px 0 2px 12px;
		padding-left: 48px !important;
		border-radius: 5px;
		color: #87CEFA !important;
		font-size: 14px !important;
		font-weight: 500 !important;
		letter-spacing: 0 !important;
		background: transparent !important;
		transition: background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease;
	}
	/deep/.el-submenu .el-menu-item:hover,
	/deep/.el-submenu .el-menu-item.is-active {
		background: linear-gradient(90deg, rgba(0, 153, 255, 0.2), rgba(0, 43, 77, 0.2)) !important;
		color: #D7F6FF !important;
		box-shadow: inset 0 0 12px rgba(0, 153, 255, 0.08);
	}
	/deep/.el-submenu__icon-arrow {
		color: #87CEFA !important;
		text-shadow: 0 0 8px rgba(0, 204, 255, 0.3);
	}
	.a-header {
		background:
			linear-gradient(180deg, rgba(0, 50, 88, 0.94), rgba(0, 22, 43, 0.96)),
			radial-gradient(circle at 22% 0%, rgba(0, 204, 255, 0.2), transparent 34%) !important;
		border-bottom: 1px solid rgba(0, 153, 255, 0.48) !important;
		box-shadow: inset 0 1px 0 rgba(176, 226, 255, 0.08), inset 0 -1px 0 rgba(0, 204, 255, 0.28), 0 12px 26px rgba(0, 8, 22, 0.28) !important;
	}
	.a-header-left {
		border-color: rgba(0, 153, 255, 0.36) !important;
		background: rgba(0, 21, 42, 0.5) !important;
		box-shadow: inset 0 0 18px rgba(0, 153, 255, 0.1);
	}
	.a-header-left a {
		border-radius: 5px !important;
		color: #B0E2FF !important;
		background: rgba(0, 43, 77, 0.2);
	}
	.a-header-left a:hover {
		background: linear-gradient(180deg, rgba(0, 153, 255, 0.3), rgba(0, 60, 102, 0.3)) !important;
		border-color: rgba(0, 204, 255, 0.66) !important;
		box-shadow: 0 0 14px rgba(0, 204, 255, 0.16), inset 0 1px 0 rgba(176, 226, 255, 0.14) !important;
	}
	.current-time,
	.user-info,
	.log-popover .el-icon-tickets,
	.feedback-entry .el-icon-chat-dot-square {
		border-radius: 16px !important;
		background: rgba(0, 21, 42, 0.62) !important;
		border-color: rgba(0, 153, 255, 0.42) !important;
		box-shadow: inset 0 0 14px rgba(0, 153, 255, 0.1);
	}
	.current-time {
		font-family: "Bahnschrift", "DIN Alternate", Consolas, "Microsoft YaHei", sans-serif !important;
		letter-spacing: 0 !important;
		color: #D7F6FF !important;
	}
	.user-info {
		transition: border-color 0.2s ease, box-shadow 0.2s ease;
	}
	.user-info:hover,
	.log-popover .el-icon-tickets:hover,
	.feedback-entry .el-icon-chat-dot-square:hover {
		border-color: rgba(0, 204, 255, 0.82) !important;
		box-shadow: inset 0 0 14px rgba(0, 153, 255, 0.14), 0 0 14px rgba(0, 204, 255, 0.16) !important;
	}
	.log-content {
		background: transparent;
		color: #B0E2FF;
	}
	.log-title {
		height: 34px;
		line-height: 34px;
		color: #D7F6FF;
		background: rgba(0, 60, 102, 0.52);
		border: 1px solid rgba(0, 153, 255, 0.28);
		border-radius: 5px;
		font-weight: 700;
	}
	.log-title > div,
	.log-item > div {
		padding: 0 8px;
		box-sizing: border-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.log-item {
		border-bottom: 1px solid rgba(0, 60, 102, 0.64) !important;
		color: #87CEFA;
	}
	.log-item:hover {
		background: rgba(0, 153, 255, 0.12);
		color: #D7F6FF;
	}
	.log-dot {
		background: #FFB84D !important;
		box-shadow: 0 0 10px rgba(255, 184, 77, 0.75);
	}
	.user-pop-item {
		background: transparent !important;
		color: #B0E2FF !important;
		transition: background-color 0.2s ease, color 0.2s ease;
	}
	.user-pop-item:hover {
		background: rgba(0, 153, 255, 0.18) !important;
		color: #FFFFFF !important;
		border-bottom-color: rgba(0, 204, 255, 0.32) !important;
	}
	@media screen and (max-width: 1280px) {
		.a-header {
			padding-right: 12px !important;
			padding-left: 12px !important;
		}
		.a-header-left a {
			padding: 0 10px;
			font-size: 12px;
		}
		.current-time {
			width: 184px;
		}
		.user-info {
			min-width: 116px;
			padding: 0 9px;
		}
	}

	@media screen and (max-width: 760px) {
		.home-page,
		.home-layout,
		/deep/.main-shell {
			width: 100%;
			height: 100%;
			min-height: 0;
		}
		/deep/.main-shell {
			flex: 1 1 100%;
		}
		/deep/.main-shell > .el-header {
			flex: 0 0 56px;
			height: 56px !important;
		}
		/deep/.main-shell > .el-main {
			overflow: hidden !important;
		}
		.a-header {
			height: 56px;
			gap: 8px;
			padding: 0 10px !important;
		}
		.mobile-menu-button {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			flex: 0 0 40px;
			width: 40px;
			height: 40px;
			padding: 0;
			border: 1px solid rgba(0, 204, 255, 0.58);
			border-radius: 8px;
			background: rgba(0, 43, 77, 0.82);
			color: #d7f6ff;
			box-shadow: inset 0 0 12px rgba(0, 153, 255, 0.14);
			font-size: 20px;
		}
		.mobile-header-title {
			min-width: 0;
			overflow: hidden;
			color: #d7f6ff;
			font-size: 15px;
			font-weight: 700;
			text-overflow: ellipsis;
			text-shadow: 0 0 10px rgba(0, 204, 255, 0.4);
			white-space: nowrap;
		}
		.a-header-left,
		.current-time,
		.user-name {
			display: none !important;
		}
		.header-right {
			gap: 6px;
			margin-left: auto;
		}
		.log-popover .el-icon-tickets,
		.feedback-entry .el-icon-chat-dot-square {
			width: 36px;
			height: 36px;
			font-size: 18px;
		}
		.user-info {
			min-width: 38px !important;
			width: 38px;
			height: 38px;
			padding: 0 !important;
			border-radius: 19px !important;
		}
		.user-info .el-popover__reference-wrapper,
		.user-info img {
			width: 28px !important;
			height: 28px !important;
		}
		/deep/.home-aside.is-mobile-drawer {
			position: fixed !important;
			top: 0;
			bottom: 0;
			left: 0;
			z-index: 102;
			width: min(82vw, 292px) !important;
			max-width: calc(100vw - 48px);
			visibility: hidden;
			transform: translateX(-100%);
			box-shadow: none;
		}
		/deep/.home-aside.is-mobile-drawer.is-preview-visible {
			visibility: visible;
			transform: translateX(0);
			box-shadow: 20px 0 48px rgba(0, 5, 18, 0.72), 1px 0 0 rgba(0, 204, 255, 0.5);
		}
		.sidebar-scrim {
			position: fixed;
			inset: 0;
			z-index: 101;
			width: 100%;
			height: 100%;
			padding: 0;
			border: 0;
			background: rgba(0, 8, 22, 0.68);
			backdrop-filter: blur(2px);
		}
		.a-main-1 {
			height: 64px;
			padding: 0 58px 0 16px;
			font-size: 17px !important;
			line-height: 64px !important;
			text-align: left;
		}
		.a-main-1::after {
			left: 16px;
			right: 58px;
		}
		.a-left-menu {
			padding: 8px !important;
			overscroll-behavior: contain;
		}
		/deep/.el-menu > .el-menu-item,
		/deep/.el-menu > .el-submenu > .el-submenu__title {
			height: 48px !important;
			margin: 3px 0;
			padding: 0 18px !important;
			line-height: 48px !important;
		}
		/deep/.el-submenu .el-menu-item {
			height: 46px !important;
			margin-left: 8px;
			padding-left: 38px !important;
			line-height: 46px !important;
		}
		.sidebar-pin-button {
			top: 12px;
			right: 10px;
			width: 40px;
			height: 40px;
			border-radius: 8px;
			transform: none;
		}
		.sidebar-pin-button:hover,
		.sidebar-pin-button:focus-visible {
			width: 40px;
		}
		.sidebar-pin-button i {
			font-size: 18px;
		}
	}

	@media screen and (max-width: 360px) {
		.mobile-header-title {
			max-width: 82px;
			font-size: 13px;
		}
		.header-right {
			gap: 4px;
		}
		.log-popover .el-icon-tickets,
		.feedback-entry .el-icon-chat-dot-square {
			width: 34px;
			height: 34px;
		}
	}
</style>
